export const usersData = [
    { 
        id:1,
        cardId:"1234567890123",
        fullName:"นาย ทดสอบ ระบบ",
        homeNumber:"137",
        moo:"10",
        road:"-",
        alley:"-",
        province:"มหาสารคาม",
        district:"เชียงยืน",
        subDistrict:"เชียงยืน",
        zipCode:"44160",
        operatorName:"test test",
        juristicNumber:"1234",
        establishmentName:"test test",
        phoneNumber:"1234567890",
        email:"test@gmail.com",
        implementDate:"09/10/2564",
        userType:"บุคคลทั่วไป"
    },
    { 
        id:2,
        cardId:"1234567890123",
        fullName:"นาย ทดสอบ ระบบ",
        homeNumber:"444",
        moo:"44",
        road:"-",
        alley:"-",
        province:"ขอนแก่น",
        district:"น้ำพอง",
        subDistrict:"น้ำพอง",
        zipCode:"44160",
        operatorName:"test test",
        juristicNumber:"1234",
        establishmentName:"test test",
        phoneNumber:"1234567890",
        email:"test@gmail.com",
        implementDate:"09/10/2564",
        userType:"นิติบุคคล"

    },
    { 
        id:3,
        cardId:"1234567890123",
        fullName:"นาย ทดสอบ ระบบ",
        homeNumber:"55",
        moo:"55",
        road:"-",
        alley:"-",
        province:"มหาสารคาม",
        district:"เชียงยืน",
        subDistrict:"เชียงยืน",
        zipCode:"44160",
        operatorName:"test test",
        juristicNumber:"1234",
        establishmentName:"test test",
        phoneNumber:"1234567890",
        email:"test@gmail.com",
        implementDate:"09/10/2564",
        userType:"นิติบุคคล"

    },
    { 
        id:4,
        cardId:"1234567890123",
        fullName:"นาย ทดสอบ ระบบ",
        homeNumber:"137",
        moo:"10",
        road:"-",
        alley:"-",
        province:"มหาสารคาม",
        district:"เชียงยืน",
        subDistrict:"เชียงยืน",
        zipCode:"44160",
        operatorName:"test test",
        juristicNumber:"1234",
        establishmentName:"test test",
        phoneNumber:"1234567890",
        email:"test@gmail.com",
        implementDate:"09/10/2564",
        userType:"บุคคลทั่วไป"

    },
    { 
        id:5,
        cardId:"1234567890123",
        fullName:"นาย ทดสอบ ระบบ",
        homeNumber:"137",
        moo:"10",
        road:"-",
        alley:"-",
        province:"มหาสารคาม",
        district:"เชียงยืน",
        subDistrict:"เชียงยืน",
        zipCode:"44160",
        operatorName:"test test",
        juristicNumber:"1234",
        establishmentName:"test test",
        phoneNumber:"1234567890",
        email:"test@gmail.com",
        implementDate:"09/10/2564",
        userType:"บุคคลทั่วไป"

    },
    { 
        id:6,
        cardId:"1234567890123",
        fullName:"นาย ทดสอบ ระบบ",
        homeNumber:"137",
        moo:"10",
        road:"-",
        alley:"-",
        province:"มหาสารคาม",
        district:"เชียงยืน",
        subDistrict:"เชียงยืน",
        zipCode:"66666",
        operatorName:"test test",
        juristicNumber:"1234",
        establishmentName:"test test",
        phoneNumber:"1234567890",
        email:"test@gmail.com",
        implementDate:"09/10/2564",
        userType:"นิติบุคคล"

    },
    { 
        id:7,
        cardId:"1234567890123",
        fullName:"นาย ทดสอบ ระบบ",
        homeNumber:"137",
        moo:"10",
        road:"-",
        alley:"-",
        province:"มหาสารคาม",
        district:"เชียงยืน",
        subDistrict:"เชียงยืน",
        zipCode:"4444",
        operatorName:"test test",
        juristicNumber:"1234",
        establishmentName:"test test",
        phoneNumber:"1234567890",
        email:"test@gmail.com",
        implementDate:"09/10/2564",
        userType:"นิติบุคคล"

    },
    { 
        id:8,
        cardId:"1234567890123",
        fullName:"นาย ทดสอบ ระบบ",
        homeNumber:"137",
        moo:"10",
        road:"-",
        alley:"-",
        province:"มหาสารคาม",
        district:"เชียงยืน",
        subDistrict:"เชียงยืน",
        zipCode:"33333",
        operatorName:"test test",
        juristicNumber:"1234",
        establishmentName:"test test",
        phoneNumber:"1234567890",
        email:"test@gmail.com",
        implementDate:"09/10/2564",
        userType:"บุคคลทั่วไป"
    },
    { 
        id:9,
        cardId:"1234567890123",
        fullName:"นาย ทดสอบ ระบบ",
        homeNumber:"137",
        moo:"10",
        road:"-",
        alley:"-",
        province:"มหาสารคาม",
        district:"เชียงยืน",
        subDistrict:"เชียงยืน",
        zipCode:"22222",
        operatorName:"test test",
        juristicNumber:"1234",
        establishmentName:"test test",
        phoneNumber:"1234567890",
        email:"test@gmail.com",
        implementDate:"09/10/2564",
        userType:"บุคคลทั่วไป"
    },
    { 
        id:10,
        cardId:"1234567890123",
        fullName:"นาย ทดสอบ ระบบ",
        homeNumber:"137",
        moo:"10",
        road:"-",
        alley:"-",
        province:"มหาสารคาม",
        district:"เชียงยืน",
        subDistrict:"เชียงยืน",
        zipCode:"11111",
        operatorName:"test test",
        juristicNumber:"1234",
        establishmentName:"test test",
        phoneNumber:"1234567890",
        email:"test@gmail.com",
        implementDate:"09/10/2564",
        userType:"ผู้ดูแลระบบ",
        position:"ผู้ดูแลระบบ",
        county:"บางพลี",
        affiliation:"กองทัพบก"
    }
]